var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8574 0C14.4095 0.000150821 14.8572 0.447977 14.8574 1C14.8574 1.55219 14.4096 1.99985 13.8574 2H2V18.5C2 18.8885 2.1586 19.2672 2.4502 19.5508C2.74284 19.8353 3.14562 20 3.57129 20H13.8574C14.4095 20.0002 14.8572 20.448 14.8574 21C14.8574 21.5522 14.4096 21.9998 13.8574 22H3.57129C2.63308 22 1.72743 21.6375 1.05566 20.9844C0.383274 20.3304 0 19.4372 0 18.5V1C0.000197863 0.447884 0.447837 0 1 0H13.8574Z",
    fill: "#3F3F3F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4258 6.55273C14.8107 6.15705 15.4439 6.14848 15.8398 6.5332L19.6973 10.2832C19.8907 10.4714 19.9999 10.7301 20 11C20 11.2699 19.8907 11.5285 19.6973 11.7168L15.8398 15.4668C15.4439 15.8518 14.8108 15.8432 14.4258 15.4473C14.0411 15.0514 14.0497 14.4182 14.4453 14.0332L16.5371 12H6.14258C5.59042 11.9998 5.14258 11.5522 5.14258 11C5.14278 10.448 5.59054 10.0002 6.14258 10H16.5371L14.4453 7.9668C14.0498 7.58176 14.041 6.94855 14.4258 6.55273Z",
    fill: "#3F3F3F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignOut);
export default __webpack_public_path__ + "static/media/SignOut.c59f04eb74a5406c1d29f887a16b0784.svg";
export { ForwardRef as ReactComponent };